import type {ReactNode} from "react";
import {X} from "lucide-react";
export function Modal({title,children,onClose}:{title:string;children:ReactNode;onClose:()=>void}){
 return <div className="modal-backdrop" onMouseDown={onClose}>
  <div className="modal" onMouseDown={e=>e.stopPropagation()}>
   <div className="modal-head"><h2>{title}</h2><button className="icon-btn" onClick={onClose}><X size={18}/></button></div>
   {children}
  </div>
 </div>
}
